<template>
  <input type="checkbox" :id="modelName" :value="modelValue" :checked="modelValue" @change="toggleSwitch('update:modelValue', $event.target.checked)" />
  <label v-if="onLabel || offLabel" :for="modelName">{{ labelText }}</label>
  <label class="no-label" v-else :for="modelName"></label>
</template>

<!-- example usage: -->
 <!-- <ToggleSwitch :modelValue="value" :modelName="key" @update:modelValue="saveSetting(key, $event)" /> -->

<script>
export default {
  name: "ToggleSwitch",

  computed: {
    labelText() {
      return this.modelValue ? this.onLabel : this.offLabel;
    },
  },

  props: {
    modelValue: {
      type: Boolean,
      default: false,
      required: true,
    },
    modelName: {
      type: String,
      required: true,
    },
    onLabel: {
      type: String,
      default: "",
      required: false,
    },
    offLabel: {
      type: String,
      default: "",
      required: false,
    },
  },
  emits: ["update:modelValue"],

  methods: {
    toggleSwitch(eventName, value) {
      this.$emit(eventName, value);
    },
  },
};
</script>

<style scoped>
input[type="checkbox"] {
  height: 0;
  width: 0;
  visibility: hidden;
  transition: all 500ms ease-in-out;
}

label {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  min-width: 90px;
  height: 40px;
  margin: 5px;
  background: grey;
  border-radius: 100px;
  position: relative;
  font-size: 0.7rem;
  font-weight: 600;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  padding: 0 20px 0 20px;
  max-width: 120px;
  transition: background-color 600ms ease-in-out, box-shadow 500ms ease;
}

label.no-label {
  min-width: 55px !important;
  max-width: 55px !important;
  height: 28px !important;
  padding: 0 !important;
}

label.no-label:after {
  width: 24px !important;
  height: 24px !important;
  left: 2px !important;
  top: 2px !important;
}

label:after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 36px;
  height: 36px;
  background: #fff;
  border-radius: 90px;
  transition: all 700ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

input:checked + label {
  background: var(--action-colour);
  color: white;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
}

input:checked + label:after {
  left: calc(100% - 65px);
  transform: translateX(27px);
}

label:active:after {
  width: 32px;
  height: 32px;
  transition: all 500ms ease-out;
}

body {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

@media only screen and (orientation: portrait) {
  input[type="checkbox"] {
    height: 0;
    width: 0;
    visibility: hidden;
  }

  input:checked + label:after {
    transform: translate(0);
  }

  /* Mobile-specific sizing */
  label {
    min-width: 80px;
    height: 33px;
    font-size: 0.7rem;
    padding: 0 20px 0 20px;
    margin: 0;
  }

  label.no-label {
    min-width: 50px !important;
    max-width: 50px !important;
    height: 28px !important;
  }

  label.no-label:after {
    width: 24px !important;
    height: 24px !important;
  }

  label:active:after {
    width: 28px;
    height: 28px;
  }

  label:after {
    width: 29px;
    height: 29px;
    transition: all 700ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  input:checked + label:after {
    left: calc(100% - 31px);
  }
}
</style>
